import React from 'react';
import {AppMenuItem} from '../../MainMenu';

interface MainAppContextProps {
    menuItems: AppMenuItem[]; // 左侧菜单
}

export const MainAppContext = React.createContext<MainAppContextProps>({
    menuItems: [],
});
